module.exports = __webpack_public_path__ + "img/vx2.24f46192.jpg";